import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from '../../shared/services/auth.service';
import {BehaviorSubject} from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ConfirmationPreloaderService {
    private orderId: any;
    private httpError: any;
    private preloadingComplete: any;

    constructor(private http: HttpClient, private auth: AuthService) {
        this.orderId = new BehaviorSubject<any>(null);
        this.httpError = new BehaviorSubject<boolean>(null);
        this.preloadingComplete = new BehaviorSubject<any>(null);
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getOrderId() {
        return this.orderId.asObservable();
    }

    setOrderId(id) {
        this.orderId.next(id);
    }

    getHttpError() {
        return this.httpError.asObservable();
    }

    setHttpError(httpError: boolean) {
        this.httpError.next(httpError);
    }

    getPreloadingComplete() {
        return this.preloadingComplete.asObservable();
    }

    setPreloadingComplete(isComplete: boolean) {
        this.preloadingComplete.next(isComplete);
    }

    getOrder(id) {
        return this.http.get(environment.amenaEndpoint + 'order/' + id, {headers: this.getHeaders()});
    }
}
